<template>
  <div class="chat-loader">
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>

<script>
export default {
  name: 'ChatLoader'
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/base/theme'

.chat-loader
  display: flex
  position: absolute
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)

  span
    width: 10px
    height: 10px
    border-radius: 50%
    display: inline-block
    margin: 0 3px
    animation: bounce 1s infinite

    @include themify($themes)
      background: themed('color-primary')

    &:nth-child(2)
      animation-delay: .3s

    &:nth-child(3)
      animation-delay: .6s

@keyframes bounce
  0%
    transform: scale(0.75)
  50%
    transform: scale(1)
  100%
    transform: scale(0.75)
</style>
